export const colors = { green: '#64b246' }
export const foo = null
